.title {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-md);
  align-items: center;
}
